
import { PaginatorResponse } from "src/app/modules/utils/model/pages-and-components.config";
import { DocumentType } from "./documentType.model";
import { Claim } from "./claim.model";

export class Client{
    id : string;
    countryCode : string;
    documentTypeId : number;
    documentNumber : string;
    name : string;
    lastName : string;
    cellphone1 : string;
    cellphone2 : string;
    cellphone3 : string;
    cellphone4 : string;
    cellphone5 : string;
    cellphone1CountryCode : string;
    cellphone2CountryCode : string;
    cellphone3CountryCode : string;
    cellphone4CountryCode : string;
    cellphone5CountryCode : string;
    email1 : string;
    email2 : string;
    email3 : string;
    email4 : string;
    email5 : string;
    externalClientId : string;
    lastPaymentStatus : boolean;
    origin : string;
    active : boolean;
    registerDate : Date;
    registrationBoUserId : string;
    favoriteCommunicationChannelId : number;
    favoritePaymentMethodId : number;
    massiveProcessId : string;
    projectId : string;
    extranetEmail : string;
    extranetCellphone : string;
    populationId : string;
    communicationFlowId : string;
    strategyId : string;
    birthdate : Date;
    gender : string;
    propensityToPay : number;
    situation? : null | "U" | "S" | "P";
    documentType? : DocumentType;
    customSituation: string;
    extraFields : ClientExtraFields;
    adviserId : string;
    adviserName : string;
    adviserLastName : string;
    adviserEmail : string;
    adviserCellphone : string;
    supervisorId : string;
    supervisorName : string;
    supervisorLastName : string;
    referents: Array<ClientReferentsFields>;
    guarantors: Array<ClientGuarantorsFields>;
    notContactable: boolean;
    notContactableRetries: number;
    status : string;
    adviserUserProjectId : number;
    projectType : string;
    dischargeDate : Date;
    parentClientId : string;
    parentClientIdLabel : string;
    businessLegalName : string;
    businessTradeName : string;
    businessLevel1Contacts : BusinessClientContact[];
    businessLevel2Contacts : BusinessClientContact[];
    businessLevel3Contacts : BusinessClientContact[];
    businessLevel4Contacts : BusinessClientContact[];
    businessLevel5Contacts : BusinessClientContact[];
    businessLevel6Contacts : BusinessClientContact[];
    businessLevel7Contacts : BusinessClientContact[];
    businessLevel8Contacts : BusinessClientContact[];
    businessLevel9Contacts : BusinessClientContact[];
    businessLevel10Contacts : BusinessClientContact[];
    additionalData : AdditionalData;
    portfolioType : string;
    populationName : string;
    claimData: ClaimData[]
    monoTypePaymentCode : string;
    monoTypeProductName : string;
    monoTypeOverdueBalance : number;
    monoTypeNextDueDate : Date;
    monoTypeNextAmount : number;
    hierarchicalLevel : number;
    hierarchicalParentId: string;
    educationalLevel: string;
    overdueMaxLevel: string;
    extraCellphones: ExtraCellphone[];
    extraEmails: ExtraEmail[];
    subscriptionPaymentStatus : string;
    subscriptionClientStatus : string;
    moonflowTalkActions: MoonflowTalkActions[];
    addressData : ClientAddressData;
    contactabilityStatus : string;
    contactabilityStatusWithoutRefGar : string;
}

export class ClaimData {
  claimId: string;
  claimCategoryCode: string;
  claimStatus: string;
}

export class AdditionalData {
  customSituations: CustomSituation[];
}

export class CustomSituation{
  situation: string;
  destination: string;
  registerDate: string | null;
  dueDate: string | null;
  channelType: string;
  hidden : boolean;
}

export class ClientPaginationResponse extends PaginatorResponse{
    content: Client[];
}

export interface ClientDTO{
    clientId : string;
    countryCode : string;
    documentTypeId : number;
    documentNumber : string;
    name : string;
    lastName : string;
    cellphone1 : string;
    cellphone2 : string;
    cellphone3 : string;
    cellphone4 : string;
    cellphone5 : string;
    cellphone1CountryCode : string;
    cellphone2CountryCode : string | null;
    cellphone3CountryCode : string | null;
    cellphone4CountryCode : string | null;
    cellphone5CountryCode : string | null;
    email1 : string;
    email2 : string;
    email3 : string;
    email4 : string;
    email5 : string;
    externalClientId : string;
    lastPaymentStatus : boolean;
    active : boolean;
    massiveProcessId : string;
    communicationFlowId : string;
    strategyId : string;
    birthdate : Date;
    gender : string;
    propensityToPay : number;
    favoriteCommunicationChannelId : number;
    favoritePaymentMethodId : number;
    customSituation: string;
    extraFields : ClientExtraFields;
    adviserId : string;
    adviserName : string;
    adviserLastName : string;
    adviserEmail : string;
    adviserCellphone : string;
    supervisorId : string;
    supervisorName : string;
    supervisorLastName : string;
    status : string;
    referents: Array<ClientReferentsFields>;
    guarantors: Array<ClientGuarantorsFields>;
    claims: Claim[];
    hierarchicalLevel : number;
    hierarchicalParentId: string;
    educationalLevel: string;
    overdueMaxLevel: string;
    extraCellphones: ExtraCellphone[];
    extraEmails: ExtraEmail[];
    customClientSituationList : CustomClientSituationRequest[];
    moonflowTalkActions: MoonflowTalkActions[];
    address : string;
    apartment : string;
    city : string;
    state : string;
    postalCode : string;
    latitude : number;
    longitude : number;
    updateAddressData? : boolean;
}

export interface BusinessClientCreateDTO{
  clientId : string;
  countryCode : string;
  documentTypeId : number;
  documentNumber : string;
  legalName : string;
  tradeName : string;
  externalClientId : string;
  parentExternalClientId : string;
  origin : string;
  active : boolean;
  massiveProcessId : string;
  boUserId : string;
  projectId : string;
  dischargeDate : Date;
  lastPaymentStatus : boolean;
  propensityToPay : number;
  populationId : string;
  communicationFlowId : string;
  strategyId : string;
  extraFields : ClientExtraFields;
  adviserUserProjectId : number;
  businessLevel1Contacts : BusinessClientContact[];
  businessLevel2Contacts : BusinessClientContact[];
  businessLevel3Contacts : BusinessClientContact[];
  businessLevel4Contacts : BusinessClientContact[];
  businessLevel5Contacts : BusinessClientContact[];
  businessLevel6Contacts : BusinessClientContact[];
  businessLevel7Contacts : BusinessClientContact[];
  businessLevel8Contacts : BusinessClientContact[];
  businessLevel9Contacts : BusinessClientContact[];
  businessLevel10Contacts : BusinessClientContact[];
  parentClientIdLabel: string | null;
  claims: Claim[];
  hierarchicalLevel : number;
}

export class ClientExtraFields{
    field1 : number;
    field2 : number;
    field3 : number;
    field4 : number;
    field5 : number;
    field6 : string;
    field7 : string;
    field8 : string;
    field9 : string;
    field10 : string;
}

export class ClientCustomVariables{
  [key: string] : string;
}

export class ClientReferentsFields{
  name : string;
  lastName : string;
  cellphone : string;
  cellphoneCountryCode : string | null;
  email : string;
  fullname? : string;
  initials? : string;
  relationship : number | null;
}

export class ClientGuarantorsFields{
  name : string;
  lastName : string;
  cellphone : string;
  cellphoneCountryCode : string | null;
  email : string;
  fullname? : string;
  initials? : string;
  relationship : number | null;
}

export enum StatusClient{
  STATUS_CREATE = 'C',
  STATUS_DELETED = 'D',
}

export class DeleteClientsBatchRequest{
  clientIds: string[] = [];
}

export class RevertDeleteClientsBatchRequest{
  clientIds: string[] = [];
  revertOPAnnulment: boolean;
}

export enum ClientSitutation{
  UP_TO_DATE_SITUATION = 'U',
  SLOW_PAYER_SITUATION = 'S',
  SLOW_PAYER_MAJOR_30_SITUATION = 'S30',
  SLOW_PAYER_MAJOR_60_SITUATION = 'S60',
  SLOW_PAYER_MAJOR_90_SITUATION = 'S90',
  FINALIZED_SITUATION = 'F',
  CLAIM_SITUATION = 'CLM',
  RECOVERY_CAMPAIGN_SITUATION = 'R',
  NO_ACTIVE_CREDIT_SITUATION = 'N',
}

export class BusinessClientContact{
  emailGroup : boolean;
  name : string;
  lastname : string;
  phoneType : string;
  phoneCountryCode : string;
  phoneNumber : string;
  phoneInternal : string;
  emailGroupName : string;
  email : string;
  fullname? : string;
  initials? : string;
  contactIndex : number;
  level?: number;

}

export enum ClientPhoneTypes{
  CELLPHONE = 'C',
  LANDLINE = 'L'
}

/**
 * Identidad mostrable de quien está detrás de un teléfono: puede ser el cliente
 * mismo o uno de sus contactos de negocio (businessLevelXContacts).
 *
 * Se conservan los campos originales además del fullName porque hay vistas que
 * necesitan el nombre y el apellido por separado (iniciales, ordenamientos).
 */
export interface ClientCallerIdentity{
  fullName : string;
  name : string | null;
  lastName : string | null;
  isBusinessLevelContact : boolean;
  /** Nivel del contacto (1-10) cuando isBusinessLevelContact es true. */
  level : number | null;
}

export enum ClientAlertSitutation{
  REFUSE_TO_PAY_SITUATION = 'REFUSE_TO_PAY_SITUATION',
  CANT_PAY_SITUATION = 'CANT_PAY_SITUATION',
  WRONG_DESTINATION_SITUATION = 'WRONG_DESTINATION_SITUATION',
  PAYMENT_RENEGOTIATION_SITUATION = 'PAYMENT_RENEGOTIATION_SITUATION',
  REFINANCE_SITUATION = 'REFINANCE_SITUATION',
  ACTIVE_RECOVERYCAMPAIGN_SITUATION = 'ACTIVE_RECOVERYCAMPAIGN_SITUATION',
  CONTACT_RESPONSE_ACTION_YES = "CONTACT_RESPONSE_ACTION_YES",
  CONTACT_RESPONSE_ACTION_NO = "CONTACT_RESPONSE_ACTION_NO",
  BROKEN_COMMITMENT = "BROKEN_COMMITMENT",
  PENDING_COMMITMENT = "PENDING_COMMITMENT",
  PAUSED_COMMUNICATION_SITUATION = "PAUSED_COMMUNICATION_SITUATION",
  RESUME_COMMUNICATION_SITUATION = "RESUME_COMMUNICATION_SITUATION",
  PENDING_PURCHASE_ORDER_SITUATION = "PENDING_PURCHASE_ORDER_SITUATION",
  PAYMENT_IN_REVIEW = "PAYMENT_IN_REVIEW",
  OUT_OF_OFFICE_SITUATION = "OUT_OF_OFFICE_SITUATION",
  NOT_CONTACTABLE = "N",
  AI_AGENT_COMMUNICATION_GENERATED = "AI_AGENT_COMMUNICATION_GENERATED",
  WRONG_OR_INCOMPLETE_LOCATION_SITUATION = "WRONG_OR_INCOMPLETE_LOCATION_SITUATION",
}

export enum ContactableIdentifier{
  CONTACTABLE = 'C',
  NO_CONTACTABLE = 'N',
}

export enum ContactabilityStatusIdentifier {
  HIGH = 'H',
  MEDIUM = 'M',
  LOW = 'L',
  UNCONTACTABLE = 'U',
  PENDING = 'P',
  NO_CONTACTED = 'N',
}

export class CustomClientSituationRequest{
  situation:string | any;
  clientId:string | any;
  channelType : string | null;
  channelTypes : string[];
  destination:string | any;
  valueSituation : boolean;
}

export enum PortFolioTypeEnum{
  RECOVERY = 'R',
  CURRENT = 'C'
}

export class ClientExtraFieldsFilter{
  clientExtraFields6: string[];
  clientExtraFields7: string[];
  clientExtraFields8: string[];
  clientExtraFields9: string[];
  clientExtraFields10: string[];
}

export enum ClientFilterStatusEnum{
  ACTIVE_TRUE = 'ACTIVE_TRUE',
  ACTIVE_FALSE = 'ACTIVE_FALSE',
  STATUS_CREATED = 'STATUS_C',
  STATUS_DELETED = 'STATUS_D'
}

export class ClientListFilterPageable extends PaginatorResponse {
    content : ClientListFilter[];
}

export class ClientListFilter{
  id: string;
  documentTypeId: number;
  documentNumber: string;
  name: string;
  lastName: string;
  businessLegalName: string;
  businessTradeName: string;
}

export class DistinctExtraFieldsPageableData extends PaginatorResponse {
    content : string[];
}

export enum HierarchicalLevel{
  CHILD  = 1,
  PARENT = 2
}

export enum ClientRelationship {
  GRANDFATHER_OR_GRANDMOTHER = 1,
  FRIEND = 2,
  COWORKER = 3,
  ACQUAINTANCE = 4,
  SPOUSE_OR_PARTNER = 5,
  BROTHER_OR_SISTER_IN_LAW = 6,
  BROTHER_OR_SISTER = 7,
  SON_OR_DAUGHTER = 8,
  GRANDSON_OR_GRANDDAUGHTER = 9,
  FATHER_OR_MOTHER = 10,
  COUSIN = 11,
  NEPHEW_OR_NIECE = 12,
  FATHER_OR_OTHER_IN_LAW = 13,
  UNCLE_OR_AUNT = 14,
  SON_OR_DAUGHTER_IN_LAW = 15,
  OTHER = 16
}

export class ExtraCellphone {
  order : number;
  cellphoneCountryCode: string;
  cellphone: string;
}

export class ExtraEmail {
  order : number;
  email:string;
}

export enum MoonflowTalkActionsCodeEnum{
  MOONFLOW_TALK_REFERENT = "MOONFLOW_TALK_REFERENT",
  MOONFLOW_TALK_CONTACT = "MOONFLOW_TALK_CONTACT",
  MOONFLOW_TALK_EMAIL = "MOONFLOW_TALK_EMAIL",
  MOONFLOW_TALK_CELLPHONE = "MOONFLOW_TALK_CELLPHONE"
}

export class MoonflowTalkActions {
  code: string;
  name: string;
  lastName: string;
  email: string;
  cellphone: string;
  cellphoneCountryCode: string;
  relationship: number;
}

export class ClientAddressData{
  address : string;
  apartment : string;
  city : string;
  state : string;
  postalCode : string;
  latitude : number;
  longitude : number;
}

export enum InteractionClientStatType{
  SEND = "S",
  DELIVERED = "D",
  READ = "R",
  CLICK = "C",
  FAILED = "F",
  INACTIVE = "I",
  REPORTED = "T"
}
